import { DotsThreeVertical } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"

interface BodyMeasurementActionsProps extends React.ComponentPropsWithoutRef<"div"> {
  canVerify?: boolean
}

const BodyMeasurementActions = ({ children, canVerify, id }: BodyMeasurementActionsProps) => {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild className="outline-hidden">
        <div data-testid="action-cell">
          <Button
            data-testid={`body-measurement-actions-${id}`}
            variant="circle"
            className="absolute top-0.5 right-0.75 h-9 w-9 p-0 outline-hidden!">
            <DotsThreeVertical />
            {canVerify && (
              <span
                data-testid={`red-dot-icon-${id}`}
                className="bg-critical absolute top-1.5 right-1.5 h-1.5 w-1.5 rounded-md"></span>
            )}
          </Button>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        hideWhenDetached
        onClick={(event) => event.stopPropagation()}
        onMouseDown={(event) => event.stopPropagation()}
        align="end"
        data-testid={`body-measurement-content-${id}`}
        className="flex min-w-56 flex-col gap-0.5 rounded-lg border-none p-2 leading-5">
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export { BodyMeasurementActions }
